var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h2',{staticClass:"heading"},[_vm._v("クイックアクセス")]),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"20px"}},[_c('quick-access')],1),_vm._v(" "),(_vm.showBinder)?[_c('h2',{staticClass:"heading"},[_vm._v("バインダー")]),_vm._v(" "),_c('folder-explorer')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }